import React from "react";

export default function APIDataFetchLoader() {
  return (
    <div id="loader">
      <div className="lds-hourglass"></div>
    </div>
  );
}
